export default "__VITE_ASSET__DHdEn39S__"